export default __webpack_public_path__ + "static/media/781.c104118c.png";